import { AuditBatchJson } from '@scale/shared/types/speedAudit';
import { useQuery } from 'react-query';
import {
  getTaskIdFromBatchName,
  isBatchNameValid,
} from 'react-scale/components/ExpertManagement/helpers/audit';
import { useAuditActions } from 'react-scale/components/ExpertManagement/stores/audit.store';
import apiFetch from 'react-scale/lib/api-fetch';

export const useFetchAuditBatches = async () => {
  const setAuditToTaskMap = useAuditActions().setAuditToTaskMap;
  return useQuery(
    'useFetchAuditBatches',
    async () => {
      const { auditBatches } = await apiFetch<{ auditBatches: AuditBatchJson[] }>(
        null,
        `corp-api/attemptAudit/auditBatches`,
        {
          method: 'GET',
        },
      );

      setAuditToTaskMap(
        Object.fromEntries(
          auditBatches
            .filter(b => isBatchNameValid(b.name ?? ''))
            .map(({ name, _id }) => [getTaskIdFromBatchName(name ?? ''), _id]),
        ),
      );
    },
    {
      refetchOnWindowFocus: false,
    },
  );
};
